import type { AIQuotaSnapshot } from 'core/hooks/useAIQuota';

/**
 * The quota pair from GET /chat/quota or from the turn's closing frame, or null if it is missing or
 * malformed: numbers sent as text would compare as strings ("3" >= "10") and read as exhausted.
 */
export function readQuotaSnapshot(payload: unknown): AIQuotaSnapshot | null {
  if (typeof payload !== 'object' || payload === null) {
    return null;
  }

  const { consumed, quota } = payload as Partial<Record<keyof AIQuotaSnapshot, unknown>>;
  if (typeof consumed !== 'number') {
    return null;
  }
  if (typeof quota === 'number') {
    return { consumed, quota };
  }
  return quota === null ? { consumed, quota: null } : null;
}
